import { timeAgo } from '@/utils/functions/timeAgo';
interface TimeAgoProps {
  timestamp: string;
}

export const TimeAgo: React.FC<TimeAgoProps> = ({ timestamp }) => {
  return <p className="text-xs text-gray-400">{timeAgo(timestamp)}</p>;
};
